import React from 'react';
import { Row } from 'antd';
import { RowProps as RowCopyProps } from 'antd/lib/row';

export type RowProps = RowCopyProps;

const ProRow: React.FC<RowProps> = React.forwardRef<any, RowProps>(
  (props, ref) => {
    const { children, ...resProps } = props;

    return (
      <Row ref={ref} {...resProps}>
        {children}
      </Row>
    );
  },
);

export default ProRow;
